import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import axios from 'axios';
import { filter, uniqBy } from 'lodash';

import baseUrl from '../../../utils/baseUrl';
import css from './select.scss';

export default class Select extends Component {
	static propTypes = {
		options: PropTypes.array,
		ajaxOptionsUrl: PropTypes.string,
		placeholder: PropTypes.string,
		className: PropTypes.string,
		onChange: PropTypes.func,
		value: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.number,
		]),
	};

	static defaultProps = {
		options: [],
		ajaxOptionsUrl: '',
		placeholder: 'Select...',
		className: '',
		value: '',
		error: false,
		onChange: () => {},
	};

	constructor(props) {
		super(props);

		this.value = this.props.value || '';
		this.mounted = true;

		this.state = {
			isActive: false,
			selected: false,
			value: this.value,
			options: props.options,
			ajaxOptions: [],
			// label: this.getLabel(this.props.options, this.value),
		};
	}

	componentDidMount() {
		if (typeof this.props.ajaxOptionsUrl === 'string' && this.props.ajaxOptionsUrl.length > 5) {
			this.getAjaxOptions(this.props.ajaxOptionsUrl, this.props);
		}
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	getAjaxOptions(path, props, retry = 0) {
		axios.get(baseUrl + path).then((res) => {
			if (res.data) {
				const filteredOptions = filter(res.data, (o) => !!(o.label && o.value));
				this.mounted && this.setState({
					...this.state,
					ajaxOptions: filteredOptions,
					options: this.combineOptions(props.options, filteredOptions),
				});
			}
		}).catch(() => {
			if (retry <= 3) {
				this.getAjaxOptions(path, props, retry + 1);
			}
		});
	}

	combineOptions(opt1, opt2) {
		return [].concat(opt1).concat(opt2);
	}

	componentWillReceiveProps(nextProps) {
		if (
			nextProps.value !== this.props.value ||
			nextProps.options !== this.props.options
		) {
			let newState = {
				...this.state,
				options: this.combineOptions(nextProps.options, this.state.ajaxOptions),
			};

			for (let i = 0; i < this.state.length; i++) {
				if (this.state[i].value === nextProps.value) {
					newState = this.setValue(this.state[i].value, this.state[i].label, newState);
				}
			}

			this.setState(newState);
		}
	}

	getLabel(opts, val) {
		if (opts && opts.length) {
			for (let i = 0; i < opts.length; i++) {
				if (opts[i].value === val) {
					return opts[i].label;
				}
			}
		}

		return val;
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.value !== this.state.value) {
			this.onChange();
		}
	}

	render() {
		let className = 'select';
		let dropdownClass = 'select__options';

		if (this.props.className) {
			className += ' ' + this.props.className;
		}

		if (this.state.isActive) {
			className += ' select--active';
			dropdownClass += ' ' + 'select__options--active';
		}

		if (this.props.dropdownClass) {
			dropdownClass += ' ' + this.props.dropdownClass;
		}

		if (this.props.error) {
			className += ' error';
		}

		return (
			<div className={className}>
				{this.renderSelected()}
				{this.state.isActive && (
					<div className='select--closer' onClick={() => this.closeMenu()}></div>
				)}
				<div
					className={dropdownClass}
					scrollbarVertical={props => <div {...props} className='scrollbar-vertical'/>}
				>
					<div className='mask'>
						{this.state.options.map(this.renderOption.bind(this))}
					</div>
				</div>
			</div>
		);
	}

	renderSelected() {
		return (
			<div
				className='select__activator'
				onClick={() => { this.toggleDropdown(); }}
				onKeyDown={(e) => {
					if (e.keyCode === 27) {
						this.closeMenu();
					}

					if (e.keyCode === 13 || e.keyCode === 32) {
						this.toggleDropdown();
					}
				}}
				tabIndex='0'>
				{this.getLabel(this.state.options, this.state.value) || this.props.placeholder}
			</div>
		);
	}

	renderOption(opt, i) {
		let className = 'select__option';
		let ref = undefined;
		if (opt.disabled) {
			className += ' select__option--disabled';
		}

		if (opt.value === this.state.value) {
			className += ' select__option--selected';
			ref = 'selected';
		}

		return (
			<div key={i} ref={ref} className={className} onClick={() => { !opt.disabled && this.selectOption(opt); }}>
				{opt.label}
			</div>
		);
	}

	closeMenu() {
		this.setState({
			...this.state,
			isActive: false,
		});
	}

	toggleDropdown() {
		let newState = {
			...this.state,
			isActive: !this.state.isActive,
		};

		if (this.refs.selected) {
			let scrollToElement = ReactDOM.findDOMNode(this.refs.selected);
			if (scrollToElement && typeof scrollToElement.getAttribute === 'function') {
				let parent = scrollToElement.parentElement;
				parent.scrollTop = scrollToElement.offsetTop;
			}
		}


		this.setState(newState);
	}

	selectOption(opt) {
		this.setState(this.setValue(opt.value, opt.label, {
			isActive: false,
		}));
	}

	onChange() {
		if (typeof this.props.onChange === 'function') {
			return this.props.onChange(this.state.value);
		}

		return false;
	}

	setValue(value = null, label = false, addedState = false) {
		// console.log(value, label);
		const newState = {
			...this.state,
			...addedState,
		};

		if (newState.value !== value) {
			// console.log(value, label);
			newState.value = (value === null) ? null : value;
			newState.label = (label && value) ? label : '';

			this.value = value;
		}

		return newState;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/form/select/select.js
 **/